import { ADMIN_ROLES } from "../../auth";

import { AppState } from "./model";
import { taskCodeSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:taskCodeId": {
        title: (state: AppState) => taskCodeSelector(state).name || "Task Code",
        "/edit": {
            title: "Edit",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        },
        ...detailRoutes
    }
});

export const routes = {
    "/taskCodes": {
        title: "Task Code Table",
        ...detailRoute(),
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create General Task",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        }
    }
};
